import React from 'react';
import {CircleFlag} from 'react-circle-flags';
import {ModelDTO} from 'hemwb-api';
import {getCountryIsoCode} from './countryMapping';
import GlobalOutlinedIcon from '../../../../assets/icons/GlobalOutlined.svg';
import {getModelGlobalAsTextValue} from '../../../../store/model';
import {Tooltip} from 'antd';

/**
 * Renders the Global/Adaptation column with country flag icons
 */
export const GlobalAdaptationCell: React.FC<{model: ModelDTO; flagOnly?: boolean; displayCountry?: boolean}> = ({
  model,
  flagOnly = false,
  displayCountry = false,
}) => {
  const isOnlyGlobal = model.metadata.global === 'true';
  if (isOnlyGlobal && !displayCountry) {
    const content = <img src={GlobalOutlinedIcon} alt="" height="25" style={{flexShrink: 0}} title="" />;

    if (flagOnly) {
      return (
        <Tooltip title="Global Model Only" placement="right">
          <span style={{display: 'inline-flex'}}>{content}</span>
        </Tooltip>
      );
    }

    return (
      <div style={{display: 'flex', alignItems: 'center', gap: '16px'}}>
        {content}
        <span>{getModelGlobalAsTextValue(model)}</span>
      </div>
    );
  }

  const countries = model.metadata.country?.split('/').filter((c) => c.trim());

  if (!countries || countries.length === 0) return <span>-</span>;

  if (countries.length > 1) {
    const content = <img src={GlobalOutlinedIcon} alt="" height="25" style={{flexShrink: 0}} title="" />;

    if (flagOnly) {
      return (
        <Tooltip title={countries.join(', ')} placement="right">
          <span style={{display: 'inline-flex'}}>{content}</span>
        </Tooltip>
      );
    }

    return (
      <div style={{display: 'flex', alignItems: 'center', gap: '16px'}}>
        {content}
        <span>({countries.length}) Adaptations</span>
      </div>
    );
  }

  // Single country
  const country = countries[0].trim();
  const isoCode = getCountryIsoCode(country);

  const flagContent = isoCode ? (
    <CircleFlag countryCode={isoCode} height="25" alt={country} title=" " style={{flexShrink: 0}} />
  ) : (
    <img src={GlobalOutlinedIcon} alt={country} height="25" style={{flexShrink: 0}} title="" />
  );

  if (flagOnly) {
    return (
      <Tooltip title={country} placement="right">
        <span style={{display: 'inline-flex'}}>{flagContent}</span>
      </Tooltip>
    );
  }

  return (
    <div style={{display: 'flex', alignItems: 'center', gap: '16px'}}>
      {flagContent}
      <span>{country}</span>
    </div>
  );
};
